import { HttpInterceptorFn } from '@angular/common/http';
import {LocaleService} from '../services/locale.service';
import {inject, Injectable} from '@angular/core';

export const localeInterceptor: HttpInterceptorFn = (req, next) => {
  const clonedRequest = req.clone({
    setHeaders: {
      'localeId': inject(LocaleService).getLocaleId().toString()
    }
  })
  return next(clonedRequest);
};
